export default "__VITE_ASSET__650c798b__"